import React from "react";

interface iconProps {
  height?: string;
  width?: string;
  hasCircle?: boolean;
}

export const EpsIcon = ({
  height,
  width,
  hasCircle = true,
}: iconProps): JSX.Element => {
  return (
    <>
      {hasCircle ? (
        <svg
          width={width ? width : "27"}
          height={height ? height : "30"}
          viewBox="0 0 380 411"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_499_21)">
            <path
              d="M303.741 57H75.9306C68.2006 57 61.9506 63.28 61.9806 71.01V132.19H317.611V71.08C317.671 63.4 311.471 57.12 303.731 57"
              fill="#FFEF76"
            />
            <path
              d="M317.61 132.189H61.9805V207.379H317.61V132.189Z"
              fill="#FFD900"
            />
            <path
              d="M84.09 357.741C71.88 357.741 61.98 347.841 61.98 335.631V243.471C26.21 253.591 0 286.471 0 325.471C0 372.531 38.15 410.671 85.2 410.671C120.84 410.671 151.36 388.791 164.08 357.731H84.09V357.741Z"
              fill="#FFD900"
            />
            <path
              d="M170.41 325.471C170.41 336.891 168.16 347.781 164.08 357.741H303.44C311.21 357.801 317.56 351.591 317.61 343.871V282.551H158.82C166.18 295.151 170.41 309.821 170.41 325.471Z"
              fill="#EF9C07"
            />
            <path
              d="M61.9805 207.369V243.469C69.3605 241.379 77.1505 240.269 85.2005 240.269C116.61 240.269 144.04 257.259 158.82 282.559H317.61V207.369H61.9805Z"
              fill="#FFBB00"
            />
            <path
              d="M158.82 282.561H61.9805V335.661C61.9805 347.861 71.8805 357.741 84.0705 357.751H164.08C168.16 347.801 170.41 336.901 170.41 325.481C170.41 309.831 166.18 295.171 158.82 282.561Z"
              fill="#FFD900"
            />
            <path
              d="M158.82 282.559C144.04 257.269 116.61 240.279 85.2005 240.279C77.1505 240.279 69.3605 241.399 61.9805 243.489V282.569H158.82V282.559Z"
              fill="#FFD900"
            />
            <circle cx="295" cy="85" r="85" fill="#EF9C07" />
          </g>
          <defs>
            <clipPath id="clip0_499_21">
              <rect width="380" height="411" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width={width ? width : "27"}
          height={height ? height : "30"}
          viewBox="0 0 380 411"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_499_21)">
            <path
              d="M303.741 57H75.9306C68.2006 57 61.9506 63.28 61.9806 71.01V132.19H317.611V71.08C317.671 63.4 311.471 57.12 303.731 57"
              fill="#FFEF76"
            />
            <path
              d="M317.61 132.189H61.9805V207.379H317.61V132.189Z"
              fill="#FFD900"
            />
            <path
              d="M84.09 357.741C71.88 357.741 61.98 347.841 61.98 335.631V243.471C26.21 253.591 0 286.471 0 325.471C0 372.531 38.15 410.671 85.2 410.671C120.84 410.671 151.36 388.791 164.08 357.731H84.09V357.741Z"
              fill="#FFD900"
            />
            <path
              d="M170.41 325.471C170.41 336.891 168.16 347.781 164.08 357.741H303.44C311.21 357.801 317.56 351.591 317.61 343.871V282.551H158.82C166.18 295.151 170.41 309.821 170.41 325.471Z"
              fill="#EF9C07"
            />
            <path
              d="M61.9805 207.369V243.469C69.3605 241.379 77.1505 240.269 85.2005 240.269C116.61 240.269 144.04 257.259 158.82 282.559H317.61V207.369H61.9805Z"
              fill="#FFBB00"
            />
            <path
              d="M158.82 282.561H61.9805V335.661C61.9805 347.861 71.8805 357.741 84.0705 357.751H164.08C168.16 347.801 170.41 336.901 170.41 325.481C170.41 309.831 166.18 295.171 158.82 282.561Z"
              fill="#FFD900"
            />
            <path
              d="M158.82 282.559C144.04 257.269 116.61 240.279 85.2005 240.279C77.1505 240.279 69.3605 241.399 61.9805 243.489V282.569H158.82V282.559Z"
              fill="#FFD900"
            />
            <circle cx="295" cy="85" r="85" fill="#EF9C07" />
          </g>
          <defs>
            <clipPath id="clip0_499_21">
              <rect width="380" height="411" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};
